import {
  Datepicker as ReactDatepicker,
  DatepickerProps as ReactDatepickerProps,
} from '@a-ui/react';
import { useField } from 'formik';
import React from 'react';
import useClassNames, { IClassNames } from '../../hooks/classNames.hooks';

interface DatepickerProps extends ReactDatepickerProps, IClassNames {}

const Datepicker: React.FC<DatepickerProps> = ({ classNames, required = true, ...props }) => {
  const [{ value }, { error }, { setValue }] = useField(props.name || '');
  const { className } = useClassNames(classNames);

  const handleChange = React.useCallback((ddmmyy: string, isValid: boolean) => {
    if (!isValid) return;

    setValue(ddmmyy);
  }, []);

  return (
    <div className={className}>
      <ReactDatepicker onChange={handleChange} required={required} {...props} />
    </div>
  );
};

export default Datepicker;
